"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var InspirationCardGroup = __importStar(require("./M_InspirationCardGroup"));
var DrawerTitleGrouping = __importStar(require("./O_DrawerTitleGrouping"));
var Hooks = __importStar(require("preact/hooks"));
var Component = function (p) {
    var title = p.title[0].toUpperCase() + p.title.slice(1);
    var _a = Hooks.useState(false), showContent = _a[0], setShowContent = _a[1];
    // Content should only show when panel has transitioned to full width
    Hooks.useEffect(function () {
        setTimeout(function () {
            setShowContent(true);
        }, p.transitionTime);
    }, []);
    return (Preact.h(Box_1.default, { "data-testid": "inspiration-card-panel", bgcolor: "background.paper", sx: {
            display: 'flex',
            height: { xs: '100%', md: '100%' },
            width: { xs: '100%', md: '100%' },
            paddingX: { xs: '0px', md: '16px 0px' },
            flexDirection: 'column',
            justifyContent: 'space-between',
            zIndex: 1,
        } }, showContent && (Preact.h(Preact.Fragment, null,
        Preact.h(DrawerTitleGrouping.Component, { title: title, onCloseClick: p.onClose }),
        Preact.h(Box_1.default, { bgcolor: "background.paper", height: "100%", width: "100%", sx: {
                overflowX: { xs: 'auto', md: 'hidden' },
                overflowY: { xs: 'hidden', md: 'auto' },
            } },
            Preact.h(InspirationCardGroup.Component, { attributes: p.attributes, onSelectOption: p.onSelectOption, isAttributeCompatible: p.isAttributeCompatible, isAttributeSelected: p.isAttributeSelected }))))));
};
exports.Component = Component;
